export const TAB_SELECTED2 = "TAB_SELECTED2";
export const TAB_NEW2 = "TAB_NEW2";
